import toast from "react-hot-toast";
import { parseISO, format, isValid } from "date-fns";
import { sr } from "date-fns/locale";
export const notif = (message: string = "", type: string = "default") => {
  const iconMap = {
    default: "✨",
    success: "✔️",
    error: "❌",
    warning: "⚠️",
    info: "📖",
  };
  toast(message, {
    icon: iconMap[type as keyof typeof iconMap],
    style: {
      position: "relative",
      background: "linear-gradient(135deg, #1e3c72, #2a5298)",
      color: "#fff",
      border: "1px solid #1e3c72",
      boxShadow: "0 0 10px 1px rgba(0, 0, 0, 0.2)",
      borderRadius: "4px",
      padding: "10px 20px",
      fontSize: "16px",
      fontWeight: "500",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      overflow: "hidden",
    },
  });
};
export function generateYears(startYear: any, endYear: any) {
  const years = [];
  for (let year: number = startYear; year <= endYear; year++) {
    years.push(year);
  }
  return years;
}
export const quarterYearEncoder = (year: any, quarter: any) => {
  if (year && quarter) {
    return `${year}/${quarter}`;
  } else {
    return "";
  }
};

export function formatCyDate(inputDate: string, locale: Locale = sr): string {
  const dateObj = parseISO(inputDate);

  if (!isValid(dateObj)) {
    console.error(`Invalid date: ${inputDate}`);
    return "";
  }

  const formattedDate = format(dateObj, "dd. MMMM yyyy. HH:mm", { locale });
  return formattedDate;
}
export const getCurrentAndPreviousQuarter = (): {
  current: string;
  previous: string;
} => {
  const now = new Date();

  const quarter = Math.floor(now.getMonth() / 3) + 1;
  const romanMap = ["I", "II", "III", "IV"];
  const current = `${now.getFullYear()}/${romanMap[quarter - 1]}`;

  let prevYear = now.getFullYear();
  let prevQuarter = quarter - 1;
  if (prevQuarter === 0) {
    prevQuarter = 4;
    prevYear -= 1;
  }
  const previous = `${prevYear}/${romanMap[prevQuarter - 1]}`;

  return { current, previous };
};

export const getFirstDayOfCurrentQuarter = () => {
  const today = new Date();
  const month = today.getMonth();
  const quarterStartMonth = Math.floor(month / 3) * 3;

  return new Date(today.getFullYear(), quarterStartMonth, 1);
};

export const getQuarterDateRange = (
  quarterString?: string
): { minDate: Date; maxDate: Date } => {
  if (!quarterString) {
    const today = new Date();
    const month = today.getMonth();
    const quarterStartMonth = Math.floor(month / 3) * 3;
    const minDate = new Date(today.getFullYear(), quarterStartMonth, 1);
    const maxDate = new Date(today.getFullYear(), quarterStartMonth + 3, 0);
    return { minDate, maxDate };
  }

  try {
    const [yearStr, romanQuarter] = quarterString.split("/");
    const year = parseInt(yearStr);

    const romanToNumber: { [key: string]: number } = {
      I: 1,
      II: 2,
      III: 3,
      IV: 4,
    };

    const quarterNumber = romanToNumber[romanQuarter];

    if (!quarterNumber || isNaN(year)) {
      throw new Error("Invalid quarter format");
    }

    const quarterStartMonth = (quarterNumber - 1) * 3;
    const quarterEndMonth = quarterStartMonth + 2;
    const minDate = new Date(year, quarterStartMonth, 1);

    const maxDate = new Date(year, quarterEndMonth + 1, 0);

    return { minDate, maxDate };
  } catch (error) {
    console.error("Error parsing quarter string:", quarterString, error);
    const today = new Date();
    const month = today.getMonth();
    const quarterStartMonth = Math.floor(month / 3) * 3;
    const minDate = new Date(today.getFullYear(), quarterStartMonth, 1);
    const maxDate = new Date(today.getFullYear(), quarterStartMonth + 3, 0);
    return { minDate, maxDate };
  }
};
